import axios from 'axios'
import { API_URL } from 'config/app'
import apiAuth from 'api/authData'

export default async () => {
  // @ts-ignore
  const authData = apiAuth.auth
  return await axios.get(`${API_URL}/medium/posts`, { auth: authData })
}
